import Finder from "./components/finder.component.vue";
Vue.component("cyt-finder", Finder);
